import BoxOfficeReport from 'src/models/box-office-report/BoxOfficeReport'
import Model, { encoders, ID, Integer, MODEL_LEVEL } from 'src/models/model'
import MovieTerm from 'src/models/movie/MovieTerm'

export default class MovieTermWeek extends Model {
  static name = 'MovieTermWeek'

  static deletable = true
  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.StudioReporting]

  static define () {
    this.fields = {
      id: {
        type: ID,
        sortable: true
      },
      movieTerm: {
        type: MovieTerm,
        default: null,
        encode: encoders.hasOne,
        output: true
      },
      type: {
        type: String,
        default: 'release'
      },
      weekNumber: {
        type: Integer,
        default: 1
      },
      termPercentHundredths: {
        type: Integer,
        default: 0
      },
      locked: {
        type: Boolean,
        default: false,
        output: true,
        excludeFromDefault: true
      },
      boxOfficeReports: {
        type: [BoxOfficeReport],
        default: () => ([]),
        output: true
      }
    }

    this.computed = {
      name () {
        let name = ''
        if (this.type === 'preview') name += 'Preview '
        name += `Week ${this.weekNumber}`
        return name
      },
      termPercent () {
        return this.termPercentHundredths / 100
      }
    }

    this.watchers = [
      [
        function () { return this.isDirty },
        async function () {
          _.each(this.boxOfficeReports?.data, boxOfficeReport => {
            boxOfficeReport.isAdjusting = this.isDirty
          })
        }
      ]
    ]
  }
}
